var map = {
	"./ar.svg": "9cda",
	"./de.svg": "93c2",
	"./en.svg": "7534",
	"./es.svg": "b45f",
	"./fr.svg": "95e0",
	"./it.svg": "b468",
	"./ja.svg": "7677",
	"./ko.svg": "e47d",
	"./nl.svg": "2cf1",
	"./pl.svg": "411d",
	"./pt.svg": "a673",
	"./tr.svg": "6919",
	"./zh.svg": "b677"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6053";